module.exports = __webpack_public_path__ + "static/media/evsc.4ec597d9.svg";